import { getPath, getInitialState, flattenObj } from "../../utils";

const initialState = {
  localityList: [],
  prevPage: -1,
  nextPage: -1,
  currentPage: 1,
  activeLocality: {},
  activeFilters: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_LOCALITY_LIST":
      return setLocalityList(state, action);
    case "SET_ACTIVE_LOCALITY":
      return setActiveLocality(state, action);
    case "SET_CURRENT_PAGE_LOCALITY":
      return setCurrentPageLocality(state, action);
    case "SET_ACTIVE_LOCALITY_FILTERS":
      return setActiveLocalityFilters(state, action);
    case "RESET_STATE_LOCALITY":
      return resetState(state, action);
    default:
      return state;
  }
}

const setActiveLocality = (state, action) => {
  return {
    ...state,
    activeLocality: flattenObj(action.payload),
  };
};

const setLocalityList = (state, action) => {
  return {
    ...state,
    localityList: getPath(action.payload, "localities", []),
    prevPage: getPath(action.payload, "pageResponse.previousPage", -1),
    nextPage: getPath(action.payload, "pageResponse.nextPage", -1),
  };
};

const setCurrentPageLocality = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};

const setActiveLocalityFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};

const resetState = (state, action) => {
  return {
    ...state,
    [action.payload.state]: getInitialState(initialState, action.payload.state),
  };
};
